<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    @for (player of Player.PLAYERS; track player.getValue()) {
        <g #remainingPieces>
            @for (piece of getRemainingPiecesTypeOfPlayer(player); track $index; let pieceIdX = $index) {
                <g id="remaining-piece-{{ piece.toString() }}"
                   (click)="onPieceClick(piece)"
                   [attr.transform]="getRemainingPieceTranslate(player, pieceIdX)">
                    <g app-ring
                       [outsideRadius]="pieceSizeToRadius.get(piece).get()"
                       [width]="ringStrokeWidth / 2"
                       [strokeWidth]="ringStrokeWidth / 4"
                       [midRingClasses]="getSidePieceClasses(piece)"
                       pointer-events="fill" />
                    <text id="player-{{ player.toString() }}-pieces-{{ piece.toString() }}-count"
                          class="backgrounded-text text-big"
                          dominant-baseline="middle"
                          dy="0.1em"
                          text-anchor="middle"
                          [attr.transform]="getRemainingPieceQuantityTransform(piece, pieceIdX)">{{ getRemainingPieceQuantity(piece) }}</text>
                </g>
            }
        </g>
    }
    <g #boardDiv>
        @for (line of board; track $index; let y = $index) {
            <g>
                @for (spaceContent of line; track $index; let x = $index) {
                    <g>
                        <rect id="click-{{ x }}-{{ y }}"
                              (click)="onBoardClick(x, y)"
                              [attr.x]="SPACE_SIZE * x"
                              [attr.y]="SPACE_SIZE * y"
                              [attr.width]="SPACE_SIZE"
                              [attr.height]="SPACE_SIZE"
                              [ngClass]="boardPieces[y][x].coordClasses"
                              class="base"/>
                        @for (pieceData of boardPieces[y][x].piecesData; track $index) {
                            <g app-ring
                               id="piece-{{ x }}-{{ y }}"
                               (click)="onBoardClick(x, y)"
                               [attr.transform]="pieceData.translate"
                               [outsideRadius]="pieceData.radius"
                               [width]="ringStrokeWidth / 2"
                               [strokeWidth]="ringStrokeWidth / 4"
                               [midRingClasses]="pieceData.classes" />
                        }
                    </g>
                }
            </g>
        }
        @if (chosenCoord.isPresent()) {
            <rect id="chosen-{{ chosenCoord.get().x }}-{{ chosenCoord.get().y }}"
                  (click)="onBoardClick(chosenCoord.get().x, chosenCoord.get().y)"
                  [attr.x]="SPACE_SIZE * chosenCoord.get().x"
                  [attr.y]="SPACE_SIZE * chosenCoord.get().y"
                  [attr.width]="SPACE_SIZE"
                  [attr.height]="SPACE_SIZE"
                  class="base no-fill selected-stroke"
                  pointer-events="fill"/>
        }
        @for (coord of victoryCoords; track coord.toString()) {
            <rect id="victory-{{ coord.x }}-{{ coord.y }}"
                  class="base no-fill victory-stroke mid-stroke"
                  [attr.x]="SPACE_SIZE * coord.x"
                  [attr.y]="SPACE_SIZE * coord.y"
                  [attr.width]="SPACE_SIZE"
                  [attr.height]="SPACE_SIZE"/>
        }
    </g>
</svg>
